import React from 'react'
import { Accordion, Spinner } from 'react-bootstrap'
import { useState } from 'react'
import { useEffect } from 'react'
import {GET_DIRECTORY_GROUPS} from '../../../graphql/Catalog/Groups/groups'
import { useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import MyAccordionItem from './MyAccordionItem'

const KnowAccordion = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [directory, setDirectory] = useState([])
    const [activeKey, setActiveKey] = useState(0)
    const { loading, error, data } = useQuery(GET_DIRECTORY_GROUPS)

    useEffect(() => {
        if (!loading) {

            if (error) {
                return toastSweetAlert({
                    mode: 'error',
                    message: error.message,
                })
            }

            let list = []

            data.getDirectoryGroups.map((item) => {

                return list.push(

                    <MyAccordionItem
                        icon={item.icon ?? null}
                        name={item.name ?? null}
                        eventKey={item.id}
                        description={
                            item.description ?? 'Sin Descripción'
                        }
                        childs={item?.CategoriesOfGroup.map((subItem) => {
                            
                            return (
                                <MyAccordionItem
                                    icon={subItem.icon ?? null}
                                    name={subItem.name ?? null}
                                    eventKey={item.id + '-' + subItem.id}
                                    description={
                                        subItem.description ?? 'Sin Descripción'
                                    }
                                    childs={subItem?.GroupsCategoriesSubOfGroupsCategory.map((subSubItem) => {
                                        return (
                                            <MyAccordionItem
                                                icon={subSubItem.icon ?? null}
                                                name={subSubItem.name ?? null}
                                                eventKey={item.id + '-' + subItem.id + '-' + subSubItem.id}
                                                description={
                                                    subSubItem.description ?? 'Sin Descripción'
                                                }
                                            />
                                        )
                                    })}
                                />
                            )
                        })}
                    />
                )
            })
            setIsLoading(false)
            setDirectory(list)
        }
    },[loading, error, data])

    return (
        <>
            {isLoading && <>
                <div className="d-flex justify-content-center align-items-center pt-5 pb-5" style={{ height: '80vh' }}>
                    <Spinner />
                </div>
            </>}

            {!isLoading &&
                <Accordion
                defaultActiveKey={ activeKey}>
                    { directory }
                </Accordion>
            }
            
        </>
    )
}

export default KnowAccordion